import { FC } from 'react';
import { formatDateSeparator } from '../../lib/helpers';

interface ChatDateSeparatorProps {
  date: string;
}

export const ChatDateSeparator: FC<ChatDateSeparatorProps> = ({ date }) => {
  return (
    <div className="flex items-center gap-4 py-3">
      <div className="flex-1 h-px bg-(--neutral-black-NB100)" />
      <span className="[font-size:var(--fs-l6)]! text-(--neutral-black-NB500) font-medium whitespace-nowrap">
        {formatDateSeparator(date)}
      </span>
      <div className="flex-1 h-px bg-(--neutral-black-NB100)" />
    </div>
  );
};
